import React from 'react'
import "./Video.css"
// import Video1 from '../../public/video/1.mp4';

const Video = () => {
  return (
    <div>
        <div className="wrapper10">
        <div className="container10">
        <div className="hero-section10">

        <div className="gallery10">
        <div className="vid-section">
      <video
         controls

      src="/video/79.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
        <div className="vid-section">
      <video
         controls

      src="/video/80.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/81.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/82.mp4"
      ></video>
    </div>
    </div>

   <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/83.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/84.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/85.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/86.mp4"
      ></video>
    </div>
    </div>

    <div className="gallery10">
    <div className="vid-section">
      <video
         controls

      src="/video/87.mp4"
      ></video>
    </div>
    </div>


    </div>
    </div>
    </div>
     </div>
  
    
  )
}

export default Video
